
import model                  from '_core/newModel';

const BANNER_UTM_PARAMS_STRING = 'utm_source=ugc&utm_medium=banner&utm_campaign=flashcards';

const packRelatedSubject = {

  /*
  ==================================================
   PLATFORM API CRUD METHODS (returns promises)
  ==================================================
  */

  index(packId, view='full', forceRelatedSubjects=false) {
    const queryString = forceRelatedSubjects ? '?force_related_subjects=true' : '';
    const path = `market/packs/${packId}/related_subjects${queryString}`;

    return new Promise((resolve, reject) => {
      try {
        model.index(path).then(res => {
          let relatedSubjects = res.relatedSubjects;

          if (view == 'banner') {
            relatedSubjects = res.relatedSubjects.map(subject => {
              const payload = subject.category ? subject.category : subject;

              return {
                key: payload.key,
                name: payload.name,
                url: `/learn/${payload.key}?${BANNER_UTM_PARAMS_STRING}`,
              }
            });
          }

          resolve(relatedSubjects);
        }).catch(err => {
          throw err;
        });
      } catch(err) {
        console.error(err);
        reject(err);
      }
    });
  },
  

  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */

};

export default packRelatedSubject;
